module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/lead_map-30a0d9ded885acbfc169001f1ee8dd8a.svg";